import React, { useState, useEffect } from 'react';
import {
    Tabs,
    Table
} from 'antd';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import CommunicationProgramForm from 'app/components/CommunicationProgramForm';
import CreateCommunicationProgram from 'app/components/CreateCommunicationProgram';
import EditCommunicationProgram from 'app/components/EditCommunicationProgram';
import EditDiffusionContainer from 'app/containers/EditDiffusionContainer';
import { clearCommunicationProgram } from 'app/actions/CommunicationProgramActions';

import { useStyles, styles } from './CommunicationProgramScreenStyles';
import { useDispatch, useSelector } from 'react-redux';

export default function CommunicationProgramScreen(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        siteId
    } = useSelector(state => state.Auth)

    const { TabPane } = Tabs;
    const [filter, setFilter] = useState([]);
    const [activeKey, setTabBar] = useState('1');
    const tabs = { '1': 'Bandeja de Programas de Comunicación', '2': 'Crear Programa de Comunicación', '3': `${siteId === 'HUB' ? 'Editar' : 'Visualizar'} Programa de Comunicación` }
    const [idCommunicationProgram, setIdCommunicationProgram] = useState();
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});

    useEffect(() => {
        return () => {
            dispatch(clearCommunicationProgram());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isAdmin={true} header='Programa de Comunicación' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Programa de Comunicación
                        </Link>
                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Tabs type='card' tabBarStyle={{ margin: 0 }} activeKey={activeKey} defaultActiveKey='1' className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                    <TabPane tab='Buscar' key='1'>
                        <Paper className={classes.paper} key='1'>
                            <CommunicationProgramForm filter={filter} setFilter={setFilter} setTab={setTabBar} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} />
                            <div style={styles.baseVerticalMargin}>
                                <CommunicationProgramContainer classes={classes} setTab={setTabBar} setIdCommunicationProgram={setIdCommunicationProgram} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData}>
                                    {(params) => {
                                        return (
                                            <div>
                                                <Table
                                                    loading={params.isLoading}
                                                    rowKey={item => String(item.idCommunicationProgram)}
                                                    columns={params.cols}
                                                    dataSource={params.communicationProgram}
                                                    onChange={params.handleTableChange}
                                                    pagination={pagination}
                                                    scroll={{ x: 400, y: (height - 395) }}
                                                    size={"small"}
                                                />
                                            </div>
                                        )
                                    }}
                                </CommunicationProgramContainer>
                            </div>
                        </Paper>
                    </TabPane>
                    {activeKey === '2' ?
                        <TabPane tab='Nuevo' key='2' className={classes.tab}>
                            <Paper className={classes.paper} key='2'>
                                <CreateCommunicationProgram setTab={setTabBar} formData={formData} />
                            </Paper>
                        </TabPane> : ''}
                    {activeKey === '3' ?
                        <TabPane tab={siteId === 'HUB' ? 'Editar' : 'Visualizar'} key='3' className={classes.tab}>
                            <Paper className={classes.paper} key='3'>
                                <CommunicationProgramContainer idCommunicationProgram={idCommunicationProgram}>
                                    {(params) => {
                                        return (
                                            <div>
                                                <EditDiffusionContainer filterData={params.filterParam}>
                                                    {(editParams) => {
                                                        return (
                                                            <div>
                                                                <EditCommunicationProgram
                                                                    setTab={setTabBar}
                                                                    idCommunicationProgram={idCommunicationProgram}
                                                                    editParam={params.filterParam}
                                                                    communicationProgramsDiffusion={editParams.communicationProgramsDiffusion}
                                                                    communicationProgramsCourse={editParams.communicationProgramsCourse}
                                                                    formData={formData} />
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </EditDiffusionContainer>
                                            </div>
                                        )
                                    }}
                                </CommunicationProgramContainer>
                            </Paper>

                        </TabPane> : ''}
                </Tabs>
            </div>

        </div>
    )
}


